module.exports = __webpack_public_path__ + "static/media/asset-icon.cd43e149.svg";